<template>
  <div>
  
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Existing Fraud Reports</h4>
          </div>
          <div class="table-responsive">
            <el-table class="table-shopping"
                      style="width: 100%"
                      :data="fraudReportsTable">
              <el-table-column min-width="140" label="Product">
                <template slot-scope="props">
                  <div class="img-container">
                    <img :src="props.row.product.imageUrl" alt="Agenda">
                  </div>
                  {{props.row.product.name}}
                </template>
              </el-table-column>
              <el-table-column min-width="140" label="Purchased From">
                <template slot-scope="props">
                  <strong>{{props.row.sellerName}}</strong><br />
                  {{props.row.websiteUrl}}
                </template>
              </el-table-column>
              <!-- <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Purchase Date">
                <template slot-scope="props">
                  {{props.row.purchase_date}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Price">
                <template slot-scope="props">
                  {{props.row.price}}
                </template>
              </el-table-column> -->
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Code">
                <template slot-scope="props">
                  {{props.row.code}}
                </template>
              </el-table-column>
              <el-table-column label="Purchased By"  min-width="140">
                <template slot-scope="props">
                  {{props.row.buyerName}}<br />
                  {{props.row.buyerEmail}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '@/store'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {Table, TableColumn} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import db from '@/components/firebase/init'
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch
    },
    computed: {
      ...mapFields(['image',
        'name'])
    },
    data () {
      return {
        user: {
          email: '',
          token: ''
        },
        newProduct: {
          image: '',
          name: ''
        },
        loading: false,
        prodSlotsRemaining: 2,
        modelValidations: {
          image: {
            required: true,
            url: true
          },
          name: {
            required: true
          }
        },
        fraudReportsTable: []
      }
    },
    methods: {
      init () {
        this.user = store.getUser()
        console.log('got user from store')
        console.log(this.user)
        this.getFraudReports()
      },
      getFraudReports () {
        let ref = db.collection(`accounts/${this.user.accountId}/fraudReports`)

        ref.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === 'added') {
              let doc = change.doc
              let fraudReport = doc.data()
              fraudReport.id = doc.id
              db.collection(`accounts/${this.user.accountId}/products`).doc(fraudReport.productId).get()
              .then(doc => {
                let product = doc.data()
                product.id = doc.id
                fraudReport.product = product
                this.fraudReportsTable.push(fraudReport)
              })
            }
          })
        })
      },
      pushProduct () {
        let newProduct = {
          image: this.newProduct.image,
          title: this.newProduct.title,
          certified_qty: 0,
          validated_qty: 0,
          fruad_reports: 0
        }
        this.productsTable.unshift(newProduct)
        this.newProduct.image = ''
        this.newProduct.title = ''
        this.prodSlotsRemaining--
        swal.fire({
          title: `Added`,
          text: newProduct.title,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      handleLike (index, row) {
        alert(`Your clicked on Like button`)
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      getSummaries (param) {
        const { columns } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.productsTable.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/FraudReports.vue